const languageAliases: Record<string, string> = {
  anchor: 'rust',
  rs: 'rust',
  solana: 'rust',
  rust: 'rust',
};

const fileNameLanguageAliases: Record<string, string> = {
  'anchor.toml': 'toml',
  'cargo.lock': 'toml',
  'cargo.toml': 'toml',
  'scarb.lock': 'toml',
  'scarb.toml': 'toml',
};

export const normalizeCodeLanguage = (language?: string | null) => {
  if (!language) return undefined;

  const normalized = language
    .trim()
    .toLowerCase()
    .replace(/^language-/, '')
    .replace(/^lang-/, '');

  return languageAliases[normalized] || normalized || undefined;
};

export const getCodeLanguageFromFileName = (fileName?: string | null) => {
  if (!fileName) return undefined;

  const normalizedFileName = fileName.trim().split(/[\\/]/).pop()?.toLowerCase();
  if (!normalizedFileName) return undefined;

  if (fileNameLanguageAliases[normalizedFileName]) {
    return fileNameLanguageAliases[normalizedFileName];
  }

  const extensionIndex = normalizedFileName.lastIndexOf('.');
  if (extensionIndex >= 0 && extensionIndex < normalizedFileName.length - 1) {
    return normalizeCodeLanguage(normalizedFileName.slice(extensionIndex + 1));
  }

  return normalizeCodeLanguage(normalizedFileName);
};

export const getCodeLanguageFromClassName = (className?: string | string[] | null) => {
  if (!className) return undefined;

  const classNames = Array.isArray(className) ? className : className.split(/\s+/);
  const languageClass = classNames.find(
    (item) => item.startsWith('language-') || item.startsWith('lang-')
  );

  return normalizeCodeLanguage(languageClass);
};
